import type { ApiEffect, Slice } from '../../index.h'
import type {
  AppearanceBanner,
  AppearanceComponent,
  AppearanceComponentContent,
  AppearanceModulesSet,
  AppearanceRow,
  AppearanceStylesSet,
} from './index.h'

import { createEffect } from 'effector'

export * from './index.h'

// GET /v3/appearance
export const getAppearanceFx: ApiEffect<void, AppearanceModulesSet> =
  createEffect()

// GET /v3/appearance
export const getAppearanceStylesFx: ApiEffect<void, AppearanceStylesSet> =
  createEffect()

// GET /v3/appearance/modules/{identifier}/rows
export const getModuleComponentsFx: ApiEffect<
  { identifier: string; page?: number; count?: number },
  Slice<AppearanceComponent>
> = createEffect()

// GET resource row
export const getRowContentFx: ApiEffect<
  AppearanceRow,
  AppearanceComponentContent
> = createEffect()

// GET resource banner
export const getBannerContentFx: ApiEffect<
  AppearanceBanner,
  AppearanceComponentContent
> = createEffect()
